import React from "react";
import "./../../../styles/details.css";
import { Container, Row, Col } from "reactstrap";
import Booking from "./../../../components/Booking/Booking";
import tour1 from "./../../../assets/images/jaipur-village-safari.jpg";
import tour7 from "./../../../assets/images/vill-1.jpg";
import tour2 from "./../../../assets/images/vill-2.jpg";
import tour3 from "./../../../assets/images/vill-3.jpg";
import tour4 from "./../../../assets/images/vill-4.jpg";
import tour5 from "./../../../assets/images/vill-5.jpg";
import tour6 from "./../../../assets/images/vill-6.jpg";
import Newsletter from "../../../shared/Newsletter";
import ImageGallery from "../../../components/Gallery/Gallery2";
import { Helmet } from "react-helmet";

const JaipurVillage = () => {
  const images = [tour7, tour2, tour3, tour4, tour5, tour6];
  return (
    <>
      <Helmet>
        <title>Jaipur Jeep Safari | The Rustic Paths</title>
        <meta name="author" content="The Rustic Paths" />
        <meta
          name="description"
          content="Travel India with a private driver and experience the best of what the country has to offer. We offer a wide range of tour packages to suit your budget and interests, including the Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour and Short Tour. Our experienced drivers will take care of all the logistics, so you can relax and enjoy your journey."
        />
        <meta name="image" content={tour1} />
      </Helmet>
      <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
      Jaipur Jeep Safari
      </h1>
      <section>
        <Container>
          <Row>
            <Col lg="12" className="details__container mx-auto">
              <img src={tour1} alt="" />
            </Col>

            <Col lg="8">
              <div className="details__container mx-auto">
                <div className="details__info">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      {/* <li>Jaipur - Village Jeep Safari</li> */}
                      <li>A quaint Jaipur village</li>
                    </ul>
                  </div>

                  <p className="mb-4">Duration: Full Day Trip</p>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold "
                      style={{ textAlign: "left" }}
                    >
                      Overview:
                    </h2>
                    <p>
                    If you’re considering Jaipur jeep safari near Jaipur, crafting the perfect package is crucial to ensure an unforgettable experience for you. Let’s delve into what your package should include to captivate tourists seeking an authentic Rajasthani adventure by the rustic paths.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Trip Highlights:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>
                      Visit several villages around Amer and witness their traditional way of living.
                      </li>
                      <li>
                      Enjoy the scenic views of villages and hills from various viewpoints.
                      </li>
                      <li>
                      Interact with the locals including school kids, farmers and their families
                      </li>
                      <li>
                      Encounter driving challenges like cattle (goats, cows, buffalos) on the way.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Detailed Itinerary:
                    </h2>

                    {/* Day 1 */}
                    <div>
                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          8:00 AM: Village School Visits
                        </summary>
                        <p>
                          Start your day with a heartwarming visit to local
                          village schools. Witness the joy and enthusiasm of the
                          children, and learn about the education system in
                          rural India.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          10:00 AM: Henna Making
                        </summary>
                        <p>
                          Engage in a traditional henna-making session. Learn
                          the intricate art from local artisans and get your
                          hands beautifully adorned.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          11:30 AM: Clay Pottery Lesson
                        </summary>
                        <p>
                          Discover the ancient art of clay pottery. Under the
                          guidance of skilled potters, try your hand at creating
                          your own masterpiece.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          1:00 PM: Meet the Farmers
                        </summary>
                        <p>
                          Gain insights into the agricultural practices of the
                          region by meeting local farmers. Understand their
                          challenges and triumphs as they share their stories.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          2:30 PM: Village Interaction
                        </summary>
                        <p>
                          Stroll through the village and meet the warm-hearted
                          villagers. Experience their hospitality and learn
                          about their daily lives and traditions.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          4:00 PM: Nature Roads Drive
                        </summary>
                        <p>
                          Enjoy a thrilling jeep drive on scenic nature roads.
                          Breathe in the fresh air and soak in the picturesque
                          views of the countryside.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          5:00 PM: Viewpoints
                        </summary>
                        <p>
                          Stop at various viewpoints to capture stunning vistas
                          of the landscape. These spots offer perfect
                          opportunities for photography and reflection.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          6:30 PM: Temple Visit
                        </summary>
                        <p>
                          Conclude your journey with a serene visit to a village
                          temple. Experience the spiritual ambiance and learn
                          about the local religious practices.
                        </p>
                      </details>

                      <p>
                        This village tour provides a deep insight into the rural
                        life of India, offering hands-on experiences, cultural
                        interactions, and scenic beauty.
                      </p>

                      {/* Continue adding details for other days as required */}
                    </div>

                    {/* Continue adding details for other days as required */}
                  </div>
                  <Col lg="12">
                    <h2>Image Gallery</h2>
                    <ImageGallery images={images} />
                  </Col>

                  <Col lg="12">
                    {/* Add the ElfSight testimonial widget div */}
                    <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
                  </Col>
                </div>
              </div>
            </Col>

            <Col lg="4">
              <Booking />
            </Col>
          </Row>
        </Container>
      </section>
      <Newsletter />
    </>
  );
};

export default JaipurVillage;
